module.exports = __webpack_public_path__ + "static/media/gw-home-cleaning-banner.6d43656b.png";